import { c as createVueApp, o as objectAssign, a as callCumulativeHooks, g as getHeadSetting } from "../getHeadSetting-Bd9Y_bSc.js";
let app;
let changePage;
const onRenderClient = async (pageContext) => {
  if (!app) {
    const container = document.getElementById("app");
    const ssr = container.innerHTML !== "";
    const res = await createVueApp(pageContext, ssr, "Page");
    changePage = res.changePage;
    app = res.app;
    objectAssign(pageContext, { app });
    await callCumulativeHooks(pageContext.config.onBeforeRenderClient, pageContext);
    app.mount(container);
  } else {
    await callCumulativeHooks(pageContext.config.onBeforeRenderClient, pageContext);
    await changePage(pageContext);
    const title = getHeadSetting("title", pageContext) || "";
    const lang = getHeadSetting("lang", pageContext) || "en";
    const favicon = getHeadSetting("favicon", pageContext);
    if (title !== void 0)
      document.title = title;
    if (lang !== void 0)
      document.documentElement.lang = lang;
    if (favicon !== void 0)
      setFavicon(favicon);
    replaceAdjacentBodyHtml(pageContext, "bodyHtmlBegin");
    replaceAdjacentBodyHtml(pageContext, "bodyHtmlEnd");
  }
};
function setFavicon(faviconUrl) {
  let link = document.querySelector("link[rel~='icon']");
  if (!faviconUrl) {
    if (link)
      document.head.removeChild(link);
    return;
  }
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = faviconUrl;
}
async function replaceAdjacentBodyHtml(pageContext, method) {
  const hooks = pageContext.config[method];
  if (!hooks)
    return;
  const hookHtml = (await callCumulativeHooks(hooks, pageContext)).join("");
  const startComment = `<!-- vike-vue:${method} start -->`;
  const endComment = `<!-- vike-vue:${method} finish -->`;
  const startIndex = document.body.innerHTML.indexOf(startComment) + startComment.length;
  const endIndex = document.body.innerHTML.indexOf(endComment);
  if (startIndex !== -1 && endIndex !== -1) {
    document.body.innerHTML = document.body.innerHTML.substring(0, startIndex) + hookHtml + document.body.innerHTML.substring(endIndex);
  }
}
export {
  onRenderClient
};
//# sourceMappingURL=onRenderClient.js.map
